import { useQuery } from "@tanstack/react-query";
import axiosPrivate from "../axiosPrivate";

export const useUserProfile = () =>
  useQuery({
    queryKey: ["userProfile"],
    queryFn: async () => {
      const res = await axiosPrivate.get("profile");
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
